import React from 'react'
import { Link } from 'gatsby'

export default function Violator({ style }){
    return(
        <Link
            to='/sale'
            className='m-0 d-block text-center text-black bg-primary fw-bold position-relative text-decoration-none'
            style={{ ...style, textWrapStyle: 'balance' }}
        >
            SPEND MORE, SAVE UP TO AN EXTRA 25% — SHOP THE SALE!
        </Link>
    )
}
